<div class="component">
    <!-- <iframe width="100%" height="100%" src="https://www.youtube.com/embed/eIWqse75sD0" title="YouTube video player" frameborder="0" allowfullscreen allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture">
        </iframe> -->
    <video width="100%" height="100%" controls autoplay>
        <source src="../../../../../assets/file/info.mp4" type="video/mp4">
    </video>
</div>